


























































































































import { Vue, Component } from 'vue-property-decorator'
import { ItemVitrineVirtual, VitrineVirtualModule } from '@/store/vuex/produto/VitrineVirtualStore'
import { hashColor } from '@/shareds/badge-utils'

@Component
export default class DialogoDoCarrinhoDaVitrineVirtual extends Vue {
	mostra = false
	hashColor = hashColor

	mostrar() {
		this.mostra = true
	}

	fechar() {
		this.mostra = false
	}

	get itensCarrinho(): ItemVitrineVirtual[] {
		return VitrineVirtualModule.dados.produtos || []
	}

	get valorTotal(): number {
		return this.itensCarrinho.reduce((total, item) => {
			return total + ((item.produto.preco || 0) * item.quantidade)
		}, 0)
	}

	get valorTotalFormatado(): string {
		return this.formatarValor(this.valorTotal)
	}

	formatarValor(valor: number): string {
		return new Intl.NumberFormat('pt-BR', {
			style: 'currency',
			currency: 'BRL',
		}).format(valor || 0)
	}

	getImagem(item: ItemVitrineVirtual): string {
		const produto = item.produto

		if (!produto.urlImagens) {
			return 'https://i.pinimg.com/originals/61/3c/ea/613ceaae3543acdf381af20da47612dc.png'
		}

		if (typeof produto.urlImagens === 'string') {
			return produto.urlImagens
		}

		if (Array.isArray(produto.urlImagens) && produto.urlImagens.length) {
			const primeira = produto.urlImagens[0]

			if (typeof primeira === 'string') return primeira
			if (primeira?.imagemUrl) return primeira.imagemUrl
			if (primeira?.url) return primeira.url
		}

		return 'https://i.pinimg.com/originals/61/3c/ea/613ceaae3543acdf381af20da47612dc.png'
	}

	alterarQuantidade(item: ItemVitrineVirtual, novaQuantidade: number) {
		if (novaQuantidade < 1) return

		const itensAtualizados = [...this.itensCarrinho]
		const alvo = itensAtualizados.find((i) => i.produto.id === item.produto.id)
		if (!alvo) return

		alvo.quantidade = novaQuantidade

		VitrineVirtualModule.setDados({
			produtos: itensAtualizados,
		})
	}

	onQuantidadeInput(item: ItemVitrineVirtual) {
		const quantidade = Number(item.quantidade) || 1
		this.alterarQuantidade(item, quantidade < 1 ? 1 : quantidade)
	}

	removerItem(item: ItemVitrineVirtual) {
		const itensAtualizados = this.itensCarrinho.filter((i) => i.produto.id !== item.produto.id)

		VitrineVirtualModule.setDados({
			produtos: itensAtualizados,
		})
	}

	limparCarrinho() {
		VitrineVirtualModule.resetar()
	}

	concluir() {
		this.$emit('finalizar', this.itensCarrinho)
		this.fechar()
	}
}
